import { EnvironmentType } from "@app/models/env";
import { environment } from "../../environments/environment";

const BASE_DEVELOPMENT = "https://srefrescos.development.supermup.com.br/api";
const BASE_HOMOLOG = "https://srefrescos.homolog.supermup.com.br/api";
const BASE_HEXT = "https://srefrescos.hext.supermup.com.br/api";
const BASE_PRODUCTION = "https://srefrescos.production.supermup.com.br/api";

const BASE_GRPC_DEVELOPMENT = "https://mobiq-hub-grpcweb.srefrescos.development.supermup.com.br";
const BASE_GRPC_HOMOLOG = "https://mobiq-hub-grpcweb.srefrescos.homolog.supermup.com.br";
const BASE_GRPC_HEXT = "https://mobiq-hub-grpcweb.srefrescos.hext.supermup.com.br";
const BASE_GRPC_PRODUCTION = "https://mobiq-hub-grpcweb.srefrescos.production.supermup.com.br";

export const endpointBase =
  environment === EnvironmentType.development
    ? BASE_DEVELOPMENT
    : environment === EnvironmentType.homolog
    ? BASE_HOMOLOG
    : environment === EnvironmentType.hext
    ? BASE_HEXT
    : BASE_PRODUCTION;

export const endpointBaseGRPC =
  environment === EnvironmentType.development
    ? BASE_GRPC_DEVELOPMENT
    : environment === EnvironmentType.homolog
    ? BASE_GRPC_HOMOLOG
    : environment === EnvironmentType.hext
    ? BASE_GRPC_HEXT
    : BASE_GRPC_PRODUCTION;

export const applicationClientId =
  environment === EnvironmentType.development
    ? "f780d3e736509b548e11f19f2d50a4610822a086"
    : environment === EnvironmentType.homolog
    ? "da39a3ee5e6b4b0d3255bfef95601890afd80709"
    : environment === EnvironmentType.hext
    ? "3a3911235d101c58b501e54259d708829865f331"
    : "0985d8bac94af7ebf3123025843223abd4932b8a";
